import { render, staticRenderFns } from "./CouponManagementIframe.vue?vue&type=template&id=dbd2fc04&"
import script from "./CouponManagementIframe.vue?vue&type=script&lang=ts&"
export * from "./CouponManagementIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports